// extracted by mini-css-extract-plugin
module.exports = {"root":"Result_root__ByivU","name":"Result_name__35KmG"};